import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}user/`;
//const baseUrl = "https://localhost:44356/api/user/"; //process.env.API_URL + "/routes/"; 

export function follow(user) {
    return fetch(`${baseUrl}followuser/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" }) 
        .then(handleResponse)
        .catch(handleError);
}

export function unfollow(user) {
    return fetch(`${baseUrl}unfollowuser/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function removeFollower(user) {
    return fetch(`${baseUrl}removefollower/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function block(user) {
    return fetch(`${baseUrl}blockuser/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function unblock(user) {
    return fetch(`${baseUrl}unblockuser/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function rejectFollower(user) {
    return fetch(`${baseUrl}rejectfollowerrequest/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function approveFollower(user) {
    return fetch(`${baseUrl}acceptfollowerrequest/${user.id}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getFollowRequests() {
    return fetch(`${baseUrl}getfollowrequests`, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}



// WEBPACK FOOTER //
// ./src/api/riderNetworkApi.js